(() => {
  document.querySelectorAll('[data-bra-contact] form').forEach(form => {
    const first = form.querySelector('[data-contact-first-name]');
    const last = form.querySelector('[data-contact-last-name]');
    const full = form.querySelector('[data-contact-full-name]');
    if (!first || !last || !full) return;
    const updateName = () => { full.value = [first.value.trim(), last.value.trim()].filter(Boolean).join(' '); };
    first.addEventListener('input', updateName);
    last.addEventListener('input', updateName);
    form.addEventListener('submit', updateName);
    updateName();
  });
})();
